// import { useTheme } from '@mui/material';
import { Box } from '@mui/material';
import { FC } from 'react';
import { CapturLogoSvg } from 'src/components/Logo/CapturLogo.svg';

interface LogoProps {
  variant?: 'icon' | 'text';
  background?: 'dark' | 'light';
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'custom';
  custom?: string;
  justifyContent?: string;
  paddingTop?: number;
  width?: number;
  height?: number;
  flex?: string;
}

const Logo: FC<LogoProps> = ({
  variant = 'text',
  background = 'light',
  width,
  height,
  size
}) => {
  // // const theme = useTheme();

  // //TODO need to work out how the theme defines the color for different conditions
  // // const contrastColor =
  // //   background === 'light'
  // //     ? theme.colors.captur.secondary.main
  // //     : theme.colors.captur.tertiary.main;

  // // the widths are fairly consistent, but need to calculate accurately
  // const defaultWidths = {
  //   icon: {
  //     xs: '20px', //  paddingTop={0.7}
  //     sm: '30px', //  paddingTop={0.7}
  //     md: '40px', //  paddingTop={1}
  //     lg: '60px', //  paddingTop={2}
  //     xl: '80px' // paddingTop={2.2}
  //   },
  //   text: {
  //     xs: '120px',
  //     sm: '170px',
  //     md: '230px',
  //     lg: '355px',
  //     xl: '465px'
  //   }
  // };

  // const width = size === 'custom' ? custom : defaultWidths[variant][size];

  return (
    <Box display="flex" justifyContent="center">
      <CapturLogoSvg
        background={background}
        variant={variant}
        width={width}
        height={height}
        size={size}
      />
    </Box>
  );
};

export default Logo;
